import React from 'react';
import ConnectionCardSkeleton from './ConnectionCardSkeleton';

const ConnectionHubSkeleton = () => {

    const LevelBarSkeleton = () => (
        <div className="bg-gray-800/70 backdrop-blur-md rounded-lg border border-gray-700/50 p-4 animate-pulse">
            <div className="flex justify-between items-center mb-1">
                <div className="h-4 bg-gray-700 rounded w-1/3"></div>
                <div className="h-4 bg-gray-700 rounded w-1/4"></div>
            </div>
            <div className="w-full bg-black/50 rounded-full h-4 border-2 border-cyan-900/50">
                <div className="h-full rounded-full bg-gray-700 w-1/2"></div>
            </div>
        </div>
    );

    const ActionsPanelSkeleton = () => (
        <div className="text-center text-gray-400 py-8">
            <div className="w-24 h-24 rounded-full mx-auto border-4 border-gray-700 bg-gray-700"></div>
            <div className="h-6 bg-gray-700 rounded w-1/2 mx-auto mt-4"></div>
            <div className="h-4 bg-gray-700 rounded w-1/3 mx-auto mt-2 mb-6"></div>
            <div className="space-y-3">
                <div className="h-12 bg-gray-700 rounded-md w-full"></div>
                <div className="h-12 bg-gray-700 rounded-md w-full"></div>
            </div>
        </div>
    );

    return (
        <div className="animate-fadeIn w-full h-full">
            <div className="relative w-full h-[85vh] lg:grid lg:grid-cols-3 lg:gap-6">
                <div className="absolute inset-0 lg:relative lg:col-span-2">
                    <div className="flex justify-center border-b border-gray-700 mb-4">
                        <div className="h-10 bg-gray-700/50 rounded-t-md w-24 mx-1"></div>
                        <div className="h-10 bg-gray-700/50 rounded-t-md w-24 mx-1"></div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
                        {[...Array(6)].map((_, i) => <ConnectionCardSkeleton key={i} />)}
                    </div>
                </div>

                <div className="absolute top-4 left-4 right-4 z-10 lg:hidden">
                    <LevelBarSkeleton />
                </div>

                <div className="hidden lg:flex lg:flex-col lg:col-span-1 lg:gap-6">
                    <LevelBarSkeleton />
                    <div className="bg-gray-800/70 backdrop-blur-md rounded-lg border border-gray-700/50 p-4 flex-grow">
                        <ActionsPanelSkeleton />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConnectionHubSkeleton;
